import React, { useState, useEffect } from "react";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import searchIcon from "../../assets/images/search-lg.svg";
import filerIcon from "../../assets/images/Up_Down.svg";
import { fetchGaon } from "../../action/gaonApi";
import Pagination from "../../components/pagination/paginationView";
import { TabPanel, Tabs } from "react-tabs";
import EditIcon from "../../assets/images/edit_btn.svg";
import viewIcon from "../../assets/images/maskIcon.svg";
import { Loader } from "../../components/loader";
import {
  fetchDistricts,
  fetchStateS,
  fetchSubDistricts,
} from "../../action/location";
import { gaonTextBasedOnRoleTYpe } from "../../helper/constants";

const Gaon = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const [filters, setFilters] = useState({
    pageNo: Number(searchParams.get("page")) || 1,
    pageSize: Number(searchParams.get("pageSize")) || 20,
    search: searchParams.get("search") || "",
    sort: searchParams.get("sort") || "name",
    order: searchParams.get("order") || 1,
    stateId: searchParams.get("stateId") || "",
    districtId: searchParams.get("districtId") || "",
    blockId: searchParams.get("blockId") || "",
  });

  const [gaonList, setGaonList] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [stateId, setStateId] = useState();
  const [districtId, setDistrictId] = useState("");
  const [blockId, setBlockId] = useState("");

  // Update URL when filters change
  useEffect(() => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.set(key, value);
    });

    // Preserve other existing params if needed
    setSearchParams(params, { replace: true });
  }, [filters, setSearchParams]);

  const fetchGaonList = async () => {
    if (!filters.stateId || !filters.districtId || !filters.blockId) {
      setGaonList([]);
      setTotalData(0);
      return;
    }

    setTotalData(0);
    setIsLoading(true);
    const response = await fetchGaon(
      filters.pageNo,
      filters.pageSize,
      filters.search,
      filters.sort,
      filters.order,
      filters.stateId,
      filters.districtId,
      filters.blockId
    );
    if (response.status) {
      setGaonList(response?.data?.list);
      setTotalData(response?.data?.totalRecords);
      setIsLoading(false);
    }
  };

  const updateFilter = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      // Reset dependent filters
      ...(key === "stateId" ? { districtId: "", blockId: "" } : {}),
      ...(key === "districtId" ? { blockId: "" } : {}),
      // Reset to first page when filters change
      ...(key !== "pageNo" ? { pageNo: 1 } : {}),
    }));
  };

  const handleReset = () => {
    setFilters({
      pageNo: 1,
      pageSize: 20,
      search: "",
      sort: "",
      order: "",
      stateId: "",
      districtId: "",
      blockId: "",
    });
    setDistricts([]);
    setBlocks([]);
  };

  // Fetch data when filters change
  useEffect(() => {
    fetchGaonList();
  }, [filters]);

  const getState = async () => {
    const res = await fetchStateS();
    if (res.status) {
      setStates(res.data);
    }
  };

  const getDistrict = async () => {
    if (!filters.stateId) return;
    const res = await fetchDistricts(filters.stateId);
    if (res.status) {
      setDistricts(res.data);
    }
  };

  const getSubDistrict = async () => {
    if (!filters.districtId) return;
    const res = await fetchSubDistricts(filters.districtId);
    if (res.status) {
      setBlocks(res.data);
    }
  };

  // useEffect(() => {
  //   fetchGaonList(search);
  // }, [pageNo, pageSize, sort, order, search]);

  useEffect(() => {
    getState();
  }, []);
  useEffect(() => {
    getDistrict();
  }, [filters.stateId]);

  useEffect(() => {
    getSubDistrict();
  }, [filters.districtId]);

  // Add this useEffect to handle initial state
  useEffect(() => {
    if (location.state?.preserveFilters && location.state?.filters) {
      setFilters(location.state.filters);
    }
  }, [location.state]);

  return (
    <>
      <div className="payout_inner_content">
        <div className="payout_data-content tablePage_content_header">
          <div className="row">
            <div className="col-lg-3">
              <div className="input-box mt-0">
                <div className="input-label">State</div>
                <select
                  className="custom_dropdn"
                  value={filters.stateId}
                  onChange={(e) => updateFilter("stateId", e.target.value)}
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state._id} value={state._id}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="input-box mt-0">
                <div className="input-label">District</div>
                <select
                  className="custom_dropdn"
                  value={filters.districtId}
                  onChange={(e) => updateFilter("districtId", e.target.value)}
                >
                  <option value="">Select District</option>
                  {districts.map((district) => (
                    <option key={district._id} value={district._id}>
                      {district.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="input-box mt-0">
                <div className="input-label">Sub District</div>
                <select
                  className="custom_dropdn"
                  value={filters.blockId}
                  onChange={(e) => updateFilter("blockId", e.target.value)}
                >
                  <option value="">Select Sub District</option>
                  {blocks.map((block) => (
                    <option key={block._id} value={block._id}>
                      {block.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="input-box mt-0">
                <div className="input-label">Search</div>
                <div className="input_field">
                  <input
                    type="text"
                    className="input"
                    placeholder="Type any keyword"
                    id="beneficiary"
                    name="search"
                    value={filters.search}
                    onChange={(e) => updateFilter("search", e.target.value)}
                    disabled={!filters.stateId}
                    title={
                      !stateId ? "please select your state" : "Search your gaon"
                    }
                  />
                  <div className="build_search">
                    <img src={searchIcon} alt="Search Icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="submit_btn_grp">
            <button
              className="btn_submit btn btn-dark"
              type="reset"
              onClick={() => {
                handleReset();
              }}
              disabled={
                !filters.search &&
                !filters.blockId &&
                !filters.stateId &&
                !filters.districtId &&
                isLoading
              }
            >
              Reset
            </button>
          </div>
        </div>
        <div className="payout_data-head">
          <div className="payout_data-head-top">
            <div className="payout_data-left">
              <div className="payout_data_ttl1">
                {gaonTextBasedOnRoleTYpe()}
              </div>
            </div>
          </div>
        </div>
        <div className="tab_box">
          <Tabs>
            <TabPanel>
              <div className="">
                <table className="payout_table upi-mandate_table">
                  <thead>
                    <tr className="tableHead">
                      <th className="thHeader">
                        <div className="payoutHead hndIcon">
                          Gaon
                          <img
                            src={filerIcon}
                            onClick={() => {
                              updateFilter("sort", "name");
                              updateFilter(
                                "order",
                                filters.order == 1 ? -1 : 1
                              );
                            }}
                            alt="filter"
                          />
                        </div>
                      </th>
                      <th className="thHeader">
                        <div className="payoutHead hndIcon">Block</div>
                      </th>
                      <th className="thHeader">
                        <div className="payoutHead hndIcon">District</div>
                      </th>
                      <th className="thHeader">
                        <div className="payoutHead hndIcon">State</div>
                      </th>
                      <th className="thHeader">
                        <div className="payoutHead hndIcon">Action</div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {filters.stateId?.length ? (
                      <>
                        {isLoading ? (
                          <tr>
                            <td colSpan="5">
                              <Loader />
                            </td>
                          </tr>
                        ) : (
                          <>
                            {gaonList?.length > 0 ? (
                              gaonList?.map((item, i) => (
                                <tr key={i}>
                                  <td>
                                    {item?.slug ? (
                                      <a className="llink1" target="_blank"
                                        href={`${process.env.REACT_APP_GAON_PAGE_URL +
                                          item?.slug
                                          }`}
                                      >
                                        {item?.gaonName}
                                      </a>
                                    ) : (
                                      item?.gaonName
                                    )}
                                  </td>
                                  <td>{item?.blockName}</td>
                                  <td>{item?.districtName}</td>
                                  <td>{item?.stateName}</td>
                                  <td>
                                    <div className="flex_btn">
                                      <Link
                                        to={`/gaon/details/${item?.gaonId}`}
                                        style={{ marginRight: "4px" }}
                                        state={{
                                          from:
                                            location.pathname + location.search,
                                          preserveFilters: true,
                                          filters: filters,
                                        }}
                                      >
                                        <img
                                          src={viewIcon}
                                          alt="view"
                                          className="eye_icon"
                                        />
                                      </Link>

                                      {/* <Link
                                        to={`/gaon/edit/${item?.gaonId}`}
                                        state={{
                                          from:
                                            location.pathname + location.search,
                                          preserveFilters: true,
                                          filters: filters,
                                        }}
                                      >
                                        <img
                                          src={EditIcon}
                                          alt="Edit"
                                          className="edit_icon"
                                        />
                                      </Link> */}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" className="text_center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={5}>
                          {" "}
                          <div className="selectState">
                            Please Select Your State
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </TabPanel>
          </Tabs>
          {gaonList?.length > 0 ? (
            <Pagination
              currentPage={filters.pageNo}
              totalCount={totalData}
              pageSize={filters.pageSize}
              onPageChange={(page) => updateFilter("pageNo", page)}
              changePageSize={(size) => updateFilter("pageSize", size)}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default Gaon;
